import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DiscussionEmbed } from 'disqus-react';
import ConfigContext from '../../../contexts/ConfigContext';

// Thread URLs are built from the city's base_url plus the canonical path
// (the same shape the sitemap emits), not from the current page URL.
// ConfigContext.href is the URL of the page that was first requested, so
// concatenating a path onto it produced
// "https://austinfoodtruck.com/food-trucks/<slug>food-trucks/<slug>" on a
// direct hit and an unrelated page's URL after client-side navigation.
// The identifier is the durable key Disqus resolves threads by; it is
// unchanged so existing threads stay attached.
function DisqusReviews({ truck, location }) {
  const { base_url, disqus_shortname } = useContext(ConfigContext);

  let disqusConfig = {};
  if (truck) {
    disqusConfig = {
      url: `${base_url}/food-trucks/${truck.id}`,
      identifier: `sft-truck-${truck.id}`,
      title: truck.name,
    };
  } else if (location) {
    disqusConfig = {
      url: `${base_url}/schedule/${location.slug}`,
      identifier: `sft-location-${location.slug}`,
      title: location.name,
    };
  }

  return (
    <DiscussionEmbed shortname={disqus_shortname} config={disqusConfig} />
  );
}

DisqusReviews.propTypes = {
  truck: PropTypes.object,
  location: PropTypes.object,
};

export default DisqusReviews;
